export class Features {
    public airCareRatingIds: Set<string> = new Set<string>();
    
    public defaultFlightSegments: number;

    public consumerDomain: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/features.model.ts